import React, { useEffect, useRef } from "react";

/**
 * Single AdSense responsive banner.
 *
 * Wrapper has the bottom-clearance CarTrack uses for the BottomNav so the ad
 * sits ABOVE the navigation bar on mobile (where pb-24 of the parent screens
 * already reserves room).
 *
 * Loads the ad slot once per mount and is a no-op in environments where
 * `window.adsbygoogle` isn't ready yet (e.g. ad-blocker or local dev).
 */
export default function AdBanner({ slot = "2762357337", testid = "ad-banner" }) {
  const ref = useRef(null);
  useEffect(() => {
    try {
      if (typeof window !== "undefined" && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (_) {
      // ad-blocker / offline — render placeholder, never break the page
    }
  }, []);
  return (
    <div data-testid={testid} className="px-3 mt-3 max-h-[250px] overflow-hidden flex justify-center" ref={ref}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-2357615785222229"
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
